import NewWindow from '@/components/svg/NewWindow';
import { LinkBehaviour, Menu } from '@/graphql/gql/graphql';
import { filterEmpty } from '@/utils/index';
import Link from 'next/link';
import { useAmplitude } from '@/utils/hooks/useAmplitude';
import { NAV_LINK_CLICKED } from '@/constants/amplitude';
import Styles from './CrossSellHeader.module.scss';

const CrossSellHeader = ({ menuItems }:Pick<Menu, 'menuItems'>) => {
  const { logAmplitudeEvent } = useAmplitude();

  return (
    <div className={Styles.container}>
      {
        filterEmpty(menuItems).map((item) => (
          <Link
            legacyBehavior
            key={`${item.text} + ${item.url}`}
            href={item.url ?? ''}
          >
            <a
              className={`${Styles.menuItem} ${item.url.includes('research') ? Styles.active : ''}`}
              aria-label={`${item.text} link`}
              href={item.url}
              target={item?.behaviour === LinkBehaviour.NewWindow ? '_blank' : '_self'}
              rel="noreferrer"
              onClick={() => logAmplitudeEvent(
                NAV_LINK_CLICKED,
                {
                  'Link Text': item?.text ?? '',
                  'Link URL': item?.url ?? '',
                  Module: 'navigation_menu',
                  Menu: 'cross_sell_header',
                },
              )}
            >
              <>
                {item.text}
                {' '}
                {item.behaviour === LinkBehaviour.NewWindow && !item.url.includes('research') && <NewWindow />}
              </>
            </a>
          </Link>
        ))
      }

    </div>
  );
};
export default CrossSellHeader;
